module.exports = __webpack_public_path__ + "public/images/program/program-12.56790cc7fb970f9307388aa4dc5b9fed.png";